import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { login } from "../actions/auth";
import LoginForm from "../components/loginform/LoginForm";

/**
 * Login : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Login module displayed on the sign-in page containing
 * the login form.
 */
class Login extends Component {
  /**
   * Submits the login credentials to the server and attempts authorization
   */
  submit = data =>
    this.props.login(data).then(() => this.props.history.push("/"));

  /**
   * Renders the React login page component
   */
  render() {
    return (
      <div className="ax-login-screen">
        <h2 className="login-title">
          <FormattedMessage
            id="login.title"
            description="Title for login form"
          />
        </h2>

        <p className="login-description">
          <FormattedMessage
            id="login.description"
            description="Description for login form"
          />
        </p>

        <LoginForm submit={this.submit} />
      </div>
    );
  }
}

Login.propTypes = {
  /**
   * history: Object
   * Navigation object to allow the component to navigate to "/"
   */
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  /**
   * login: (data) => Promise
   * Dispatches a login action via Redux and returns a Promise.
   */
  login: PropTypes.func.isRequired
};

export default connect(
  null,
  { login }
)(Login);



// WEBPACK FOOTER //
// ./src/modules/Login.js